<template>
  <div class="distrbution">
    <el-card>
      <div class="title">
        <span></span>
        <p>人口统计概览</p>
      </div>
      <!-- 总人口 -->
      <div class="count">
        <el-row :gutter="20" justify="center">
          <el-col :span="6">
            <div class="count_info">
              <div class="let_r">
                <img src="@/assets/img/qiye/zonghushu.png" alt="" />
              </div>
              <div class="conet_sub">
                <p>企业总数（家）</p>
                <h3>6190</h3>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="count_info">
              <div class="let_r" style="background:#4BCED0">
                <img src="@/assets/img/qiye/zongrenshu.png" alt="" />
              </div>
              <div class="conet_sub">
                <p>就业人数（人）</p>
                <h3>82307</h3>
              </div>
            </div></el-col
          >
          <el-col :span="6">
            <div class="count_info">
              <div class="let_r" style="background:#FB6260">
                <img src="@/assets/img/qiye/yingyeshouru.png" alt="" />
              </div>
              <div class="conet_sub">
                <p>营业收入（亿元）</p>
                <h3>967.21</h3>
              </div>
            </div></el-col
          >
          <el-col :span="6">
            <div class="count_info">
              <div class="let_r" style="background:#8167F5">
                <img
                  src="@/assets/img/qiye/gongyeyongdidijunshuishou.png"
                  alt=""
                />
              </div>
              <div class="conet_sub">
                <p>企业税收（亿元）</p>
                <h3>
                  1017
                </h3>
              </div>
            </div></el-col
          >
        </el-row>
      </div>
    </el-card>
  </div>
</template>

<script>
import { infoTongJiList } from "@/network";
export default {
  data() {
    return {
      getDataObj: {},
    };
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.distrbution {
  .title {
    display: flex;
    align-items: center;
    span {
      width: 2px;
      height: 16px;
      background: #0079fe;
      margin: 0 10px 0 0px;
    }
  }
  .count {
    padding: 20px 0 10px 0;
    .el-row {
      text-align: center;
      .count_info {
        width: 100%;
        height: 69px;
        display: flex;
        justify-content: center;
        align-items: center;
        .let_r {
          background: #52c1f5;
          width: 61px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 3px;
          img {
            width: 32px;
            height: 32px;
          }
        }
        .conet_sub {
          margin: 0 10px;
          p {
            padding: 5px 0;
            font-size: 11px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #b9bac4;
          }
        }
      }
    }
  }
}
</style>
